export const errors = {
  ok: 'Okay',
  marketplace_not_found: 'Marketplace not found',
  menu_item_not_found: 'Menu Item Not found',
  menu_item_error: 'Error Loading Menu Item',
  no_outlets_categories: 'No outlets are available for your search',
  getting_location_error:
    'Could not get coordinates. Check browser has location permissions enabled.',
  getting_location_not_supported:
    'Could not get coordinates. Your browser does not support location services.',
  location_error: 'Location Error',
  postcode_error_title: 'Invalid Postcode',
  postcode_error_subtitle: 'Unfortunately, this postcode could not be found.',
  no_fulfilment_available: 'No Fulfilment Available',
} as const
